import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout/layout'
import WidgetBuilder from '../components/builders/widget-builder'
import PuxMetaTags from '../components/shared/PuxMetaTags'
import CollapseItem, { CollapseItemProps } from '../components/CollapseItem'
import { useSpring, animated } from 'react-spring'
import { Sticky } from 'react-sticky'
import { t } from 'ttag'
import BreadCrumbs from '../components/BreadCrumbs'

const HowDoWeWork = ({ data, pageContext }: any) => {
  const page = data.orchard.puxDesignHowDoWeWork[0]
  const collapses = page.puxDesignHowDoWeWorkCollapses.contentItems
  const [isOpen, setOpen] = React.useState(true)
  const pmRef = React.useRef<HTMLDivElement>(null)
  const [navPos, setNavPos] = React.useState<number | undefined>(0)

  React.useEffect(() => {
    pmRef.current?.clientHeight
      ? setNavPos(0 - document.getElementsByTagName(`header`)[0].offsetHeight + pmRef.current?.offsetTop)
      : setNavPos(0 - document.getElementsByTagName(`header`)[0].offsetHeight)
  }, [])

  const springAnim = useSpring({
    maxHeight: isOpen ? 400 : 0,
    from: {
      maxHeight: isOpen ? 0 : 400,
    },
  })

  return (
    <Layout localizedPath={page.localization?.localizations}>
      <PuxMetaTags {...pageContext.metaTagsData} />
      <BreadCrumbs
        default={true}
        center={false}
        items={[
          {
            path: page.path,
            displayText: page.displayText,
          },
        ]}
      />

      <div className="pux-container">
        <div className="pux-container">
          <h1 className="center-content">{page.puxDesignHowDoWeWorkDisplayTitle}</h1>
        </div>

        <div className="how-do-we-work" ref={pmRef}>
          <div className="left">
            <div className={`collapse-wrap ${isOpen ? ` open` : ``}`}>
              <Sticky topOffset={navPos} disableCompensation>
                {({ style, isSticky }: { style: React.CSSProperties; isSticky: boolean }) => (
                  <div className={`pm-collapse-wrap` + (isSticky ? ` fixed` : ``)} style={style}>
                    <div className="collapse">
                      <div
                        className="collapse-title"
                        onClick={() => setOpen(!isOpen)}
                      >{t`PuxDesign.HowDoWeWork.PM`}</div>
                      <animated.div
                        className="collapse-description"
                        style={springAnim}
                        dangerouslySetInnerHTML={{
                          __html: page.puxDesignHowDoWeWorkPMDescription?.replace(/font-size: 1rem;/g, ``),
                        }}
                      ></animated.div>
                    </div>
                    <div className="collapse-info">
                      <div className="collapse-info-item">
                        <span className="label">{t`PuxDesign.HowDoWeWork.Duration`}</span>
                        <span className="value">{page.puxDesignHowDoWeWorkPMDuration}</span>
                      </div>
                      <div className="collapse-info-item">
                        <span className="label">{t`PuxDesign.HowDoWeWork.Output`}</span>
                        <span className="value">{page.puxDesignHowDoWeWorkPMOutput}</span>
                      </div>
                    </div>
                  </div>
                )}
              </Sticky>
            </div>
          </div>
          <div className="right">
            {collapses.map((collapse: CollapseItemProps) => (
              <CollapseItem {...collapse} />
            ))}
          </div>
        </div>
      </div>

      <div className="text-block">
        <WidgetBuilder widgetBuilderData={pageContext.widgets} />
      </div>
    </Layout>
  )
}

export default HowDoWeWork

export const query = graphql`
  query($pagePath: String = "") {
    orchard {
      puxDesignHowDoWeWork(first: 1, where: { path: $pagePath }) {
        displayText
        path
        puxDesignHowDoWeWorkDisplayTitle
        puxDesignHowDoWeWorkPMDescription
        puxDesignHowDoWeWorkPMDuration
        puxDesignHowDoWeWorkPMOutput
        localization {
          localizations {
            ... on Orchard_PuxDesignHowDoWeWork {
              path
              published
              localization {
                culture
              }
            }
          }
        }
        puxDesignHowDoWeWorkCollapses {
          contentItems {
            ... on Orchard_PuxDesignCollapseItem {
              contentItemId
              puxDesignCollapseItemColor
              puxDesignCollapseItemDescription {
                html
              }
              puxDesignCollapseItemDisplayTitle
              puxDesignCollapseItemDuration
              puxDesignCollapseItemOutput
              puxDesignCollapseItemIsOptional
              puxDesignCollapseItemtOpened
              puxDesignCollapseItemNestedCollapses {
                contentItems {
                  ... on Orchard_PuxDesignCollapseItem {
                    contentItemId
                    puxDesignCollapseItemColor
                    puxDesignCollapseItemDescription {
                      html
                    }
                    puxDesignCollapseItemDisplayTitle
                    puxDesignCollapseItemDuration
                    puxDesignCollapseItemOutput
                    puxDesignCollapseItemIsOptional
                    puxDesignCollapseItemtOpened
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
